<template>
	<div class="groupFields" :class="{'onlyView': getPermissionAction}">
		<div class="groupField">
			<div class="groupFieldTitle">
				<span>Customer files</span>
				<button type="button" @click="onOpenPopup">
					<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
				</button>
			</div>
			<div v-if="filesList.length" class="customer_file-wrap">
				<div class="customer_file head">
					<div class="customer_file-item">Created date</div>
					<div class="customer_file-item">Create by</div>
					<div class="customer_file-item">Invoice #</div>
					<div class="customer_file-item">Parts</div>
					<div class="customer_file-item">Labor</div>
					<div class="customer_file-item">Total</div>
					<div class="customer_file-item">File name</div>
				</div>
				<template
						v-for="({ id, created_by, labor, created_at, parts, total, invoice, file_name, file }, idx) in filesList">
					<div class="customer_file" :key="id">
						<div class="customer_file-item">{{ created_at }}</div>
						<div class="customer_file-item">{{ created_by }}</div>
						<div class="customer_file-item">{{ invoice }}</div>
						<div class="customer_file-item">{{ parts }}</div>
						<div class="customer_file-item">{{ labor }}</div>
						<div class="customer_file-item">{{ total }}</div>
						<div class="customer_file-item">{{ file_name }}</div>
						<div class="btnGroups">
							<button :class="{'hideFile': !getAcceptFiles(file_name)}" type="button" @click="previewAction(file)">
								<svg-sprite height="20" width="20" icon-id="eye"></svg-sprite>
							</button>
							<button :class="{'hideFile': !getAcceptFiles(file)}" type="button" @click="onDownload(file)">
								<svg-sprite height="18" width="18" icon-id="icon_download"></svg-sprite>
							</button>
							<button type="button" @click="onDeleteItem(idx, id)">
								<svg-sprite height="20" width="20" icon-id="deleteItem"></svg-sprite>
							</button>
						</div>
					</div>
				</template>
				<div class="customer_file bottom">
					<div class="customer_file-item">n: <span>{{ filesList.length }}</span></div>
					<div class="customer_file-item"></div>
					<div class="customer_file-item"></div>
					<div></div>
				</div>
			</div>
		</div>
		<invoice-popup
				v-if="isPopup"
				@updateClose="onClose"
				@updateFilesList="onFilesList"
				@updateView="previewAction"
				:fileType="fileType"
				:createBy="createBy"
		></invoice-popup>
		<a style="display: none" target="_blank" :href="downloadLink" download class="d-none" ref="downloadFile"></a>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import InvoicePopup from "@/components/Fleet/WorkOrders/AddWorkOrders/SecondTab/InvoicePopup/InvoicePopup";
// services
import { getAppUrl } from "@/services";

export default {
	name: "SecondTab",
	components: {
		InvoicePopup
	},
	props: {
		files: Array,
		fileType: Array,
		createBy: String,
		getPermissionAction: Boolean
	},
	computed: mapGetters([ 'driversList' ]),
	data: () => ({
		downloadLink: null,
		filesList: [],
		isPopup: false
	}),
	methods: {
		...mapActions([ 'getDeleteFiles', 'getDriverDeleteFiles', 'getInvoiceDelete' ]),
		getAcceptFiles(value) {
			const accept = [ 'png', 'jpeg', 'bmp', 'png', 'pdf', 'gif', 'jpg' ];
			const str = value && value.split('.').pop().toLowerCase();

			return accept.includes(str);
		},
		previewAction(file) {
			this.$emit('updatePreviewAction', file.includes('data:') ? file : getAppUrl + file);
		},
		onOpenPopup() {
			this.isPopup = true;
		},
		onDeleteItem(idx, id) {
			if (id) this.getInvoiceDelete({ id });
			this.filesList.splice(idx, 1);
			this.$emit('updateData', this.filesList);
		},
		onDownload(url) {
			this.downloadLink = getAppUrl + url;
			this.$nextTick(() => {
				this.$refs.downloadFile.click();
			});
		},
		onClose() {
			this.isPopup = false;
		},
		onFilesList(file) {
			this.filesList.push(file);
		}
	},
	mounted() {
		this.filesList = this.files;
	}
};
</script>

<style scoped lang="scss">
@import "secondTab";
</style>
